import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { ReportInfo, ReportRecord, ReportView, TemplateProjectionMap } from '../../../../models/report.model';
import { TemplateField } from '../../../../models/template.model';
import { NgTemplateOutlet, AsyncPipe } from '@angular/common';
import { ReportFieldFormatterPipe } from '../../../../shared/pipes/report-field-formatter.pipe';
import { SelectTemplateOutletPipe } from '../../../../shared/pipes/select-template-outlet.pipe';
import { ReportFieldRouteFnPipe } from '../../../../shared/pipes/report-field-route-fn.pipe';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ppt-record-header',
  templateUrl: './record-header.component.html',
  styleUrl: './record-header.component.scss',
  imports: [
    NgTemplateOutlet,
    AsyncPipe,
    ReportFieldFormatterPipe,
    SelectTemplateOutletPipe,
    ReportFieldRouteFnPipe
],
})
export class RecordHeaderComponent {
  readonly reportRecordData = input<ReportRecord>();
  readonly reportData = input<ReportInfo>();
  readonly currentView = input<ReportView>();
  readonly headerFields = input<TemplateField[]>();
  readonly templateProjectionMap = input<TemplateProjectionMap>();
}
